.editable_button {
	display: flex;

	.button_confirm {
		width: 50%;
		border: none;
		background-color: #81ba43;
		color: white;
		margin: 0.2rem 2px;
		border-radius: 5px;
		cursor: pointer;
		font-size: 13px;
		padding: 3px;

		&:hover {
			background-color: #5f9129;
		}
	}

	.button_cancel {
		width: 50%;
		border: none;
		background-color: #dc3545;
		color: white;
		margin: 0.2rem 2px;
		border-radius: 5px;
		cursor: pointer;
		font-size: 13px;
		padding: 3px;

		&:hover {
			background-color: #a71d2a;
		}
	}
}

.add_button {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #81ba43;
	color: white;
	padding: 0.3rem 0.5rem;
	margin: 0.2rem 2px;
	border-radius: 5px;
	cursor: pointer;
	font-size: 12px;

	&:hover {
		background-color: #5f9129;
	}
}
